import PropTypes from 'prop-types';
import React from 'react';

import Icons from 'src/assets/Icons';

import CallItem from '../CallItem';

const VideoCallItem = ({ videoCall, videoCallIds, setVideoCallIds, relatedClients }) => {
  const { id, totalDuration, clientId, startedAt, createdAt } = videoCall;
  const isChecked = videoCallIds.includes(id);
  const client = relatedClients.find((client) => client.id === clientId);

  const checkboxHandler = () =>
    setVideoCallIds((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));

  return (
    <CallItem
      id={id}
      idPrefix="video"
      isChecked={isChecked}
      checkboxHandler={checkboxHandler}
      icon={Icons.videoCallIcon}
      label="Video Call"
      client={client}
      callCreatedAt={startedAt || createdAt}
      duration={totalDuration}
    />
  );
};

VideoCallItem.propTypes = {
  videoCall: PropTypes.object,
  videoCallIds: PropTypes.array,
  setVideoCallIds: PropTypes.func,
  relatedClients: PropTypes.arrayOf(PropTypes.object),
};

export default VideoCallItem;
